import React from 'react';
import CheckboxListElementComponent from './CheckboxListElementComponent';
import DateOfBirthElementComponent from './DateOfBirthElementComponent';
import DescriptionElementComponent from './DescriptionElementComponent';
import LabelElementComponent from './LabelElementComponent';
import PhoneNumberElementComponent from './PhoneNumberElementComponent';
import RadioButtonListElementComponent from './RadioButtonListElementComponent';
import TextboxElementComponent from './TextboxElementComponent'; // Import other elements if needed
import TitleElementComponent from './TitleElementComponent';
import { FormElement } from 'models/forms/formElements/FormElement';
import { CheckboxListElement } from 'models/forms/formElements/CheckboxListElement';
import { DateOfBirthElement } from 'models/forms/formElements/DateOfBirthElement';
import { DescriptionElement } from 'models/forms/formElements/DescriptionElement';
import { LabelElement } from 'models/forms/formElements/LabelElement';
import { PhoneNumberElement } from 'models/forms/formElements/PhoneNumberElement';
import { RadioButtonListElement } from 'models/forms/formElements/RadioButtonListElement';
import { TextboxElement } from 'models/forms/formElements/TextboxElement';
import { TitleElement } from 'models/forms/formElements/TitleElement';

interface FormElementRendererProps {
  element: FormElement;
  onDelete: (id: string) => void;
  isEditing: boolean;
  onUpdate: (updatedElement: FormElement) => void;
  isDisabled?: boolean;
}

const FormElementRenderer: React.FC<FormElementRendererProps> = ({ element, onDelete, isEditing, onUpdate, isDisabled }) => {
  switch (element.type) {
    case 'Models.Forms.FormElements.Textbox':
      return <>
      <TextboxElementComponent element={element as TextboxElement} isEditing={isEditing} onUpdate={onUpdate} isDisabled={isDisabled} />
      </>
    case 'Models.Forms.FormElements.CheckBoxList':
      return (
        <CheckboxListElementComponent
          element={element as CheckboxListElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
        />
      );
    case 'Models.Forms.FormElements.RadioButtonList':
      return (
        <RadioButtonListElementComponent
          element={element as RadioButtonListElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
        />
      );
    case 'Models.Forms.FormElements.DateOfBirth':
      return (
        <DateOfBirthElementComponent
          element={element as DateOfBirthElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
        />
      );
    case 'Models.Forms.FormElements.Label':
      return (
        <LabelElementComponent
          element={element as LabelElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
        />
      );
    case 'Models.Forms.FormElements.Description':
      return (
        <DescriptionElementComponent
          element={element as DescriptionElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
        />
      );
    case 'Models.Forms.FormElements.PhoneNumber':
      return (
        <PhoneNumberElementComponent
          element={element as PhoneNumberElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
        />
      );
    case 'Models.Forms.FormElements.Title':
      return (
        <TitleElementComponent
          element={element as TitleElement}
          isEditing={isEditing}
          onUpdate={onUpdate}
        />
      );
    // Add more cases for other element types, e.g., Checkbox, Radio, etc.
    default:
      return (
        <div>
          <p>Unknown element type: {element.type}</p>
          <button onClick={() => onDelete(element.id)}>Remove</button>
        </div>
      );
  }
};

export default FormElementRenderer;
